import * as mammoth from 'mammoth';

export const convertDocxToText = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (event: Event) => {
      const target = event.target as FileReader;
      const arrayBuffer = target.result as ArrayBuffer;
      
      mammoth.extractRawText({ arrayBuffer })
        .then(result => resolve(result.value))
        .catch(error => reject(error));
    };
    
    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
};